import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/plaque/_components/PlaqueDesigner.tsx");
